// extracted by mini-css-extract-plugin
module.exports = {"menu":"NavCircle_menu__1xTup"};